import { apiRequest } from '../../app/api';

export const importMakerworldProduct = async ({ url }) => {
  return apiRequest('/makerworld-import/import', {
    method: 'POST',
    body: JSON.stringify({ url }),
  });
};
